import React, { useEffect, useState } from 'react';
import { History, LogIn, AtSign, Wallet, FileText, Ticket, ShieldAlert, Pencil, KeyRound, UserPlus, RotateCcw } from 'lucide-react';
import { adminApi, apiError, fmtDate } from '../portal/api';
import { ErrorBox, Skeleton } from '../portal/ui';

const KIND = {
  login: [LogIn, 'bg-sky-100 text-sky-700', 'Login'], email_change: [AtSign, 'bg-violet-100 text-violet-700', 'Email'], payment: [Wallet, 'bg-emerald-100 text-emerald-700', 'Payment'],
  invoice: [FileText, 'bg-amber-100 text-amber-700', 'Invoice'], ticket: [Ticket, 'bg-orange-100 text-orange-700', 'Ticket'], service: [ShieldAlert, 'bg-red-100 text-red-700', 'Service'],
  edit: [Pencil, 'bg-slate-200 text-slate-700', 'Edit'], password: [KeyRound, 'bg-fuchsia-100 text-fuchsia-700', 'Password'], account: [UserPlus, 'bg-blue-100 text-blue-700', 'Account'], restore: [RotateCcw, 'bg-teal-100 text-teal-700', 'Restore'],
};
const FILTERS = [['all', 'All'], ['login', 'Logins'], ['email_change', 'Email changes'], ['payment', 'Payments'], ['invoice', 'Invoices'], ['ticket', 'Tickets'], ['service', 'Service']];

export const CustomerActivity = ({ customerId }) => {
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [filter, setFilter] = useState('all');
  const [open, setOpen] = useState(true);
  useEffect(() => {
    setData(null); setErr('');
    adminApi.get(`/api/portal-admin/customers/${customerId}/activity`).then((r) => setData(r.data)).catch((e) => setErr(apiError(e)));
  }, [customerId]);
  const events = (data?.events || []).filter((e) => filter === 'all' || e.type === filter);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-3 space-y-2" data-testid="customer-activity">
      <div className="flex items-center gap-2">
        <p className="text-xs font-bold text-slate-600 flex items-center gap-1"><History className="h-3.5 w-3.5" />Activity timeline{data && <span className="text-slate-400 font-medium">· {data.events.length} events</span>}</p>
        <button onClick={() => setOpen(!open)} className="ml-auto text-xs px-2.5 py-1.5 rounded-lg border border-slate-300 hover:border-[#1E3A8A] font-semibold" data-testid="activity-toggle-btn">{open ? 'Hide' : 'Show'}</button>
      </div>
      {open && (
        <>
          <div className="flex flex-wrap gap-1" data-testid="activity-filters">
            {FILTERS.map(([k, l]) => <button key={k} onClick={() => setFilter(k)} className={`text-[11px] px-2 py-1 rounded-full border font-semibold ${filter === k ? 'bg-[#1E3A8A] text-white border-[#1E3A8A]' : 'border-slate-300 text-slate-600 hover:border-[#1E3A8A]'}`} data-testid={`activity-filter-${k}`}>{l}{data && k !== 'all' && data.counts[k] ? ` (${data.counts[k]})` : ''}</button>)}
          </div>
          <ErrorBox message={err} />
          {!data && !err && <Skeleton className="h-24" />}
          {data && !events.length && <p className="text-xs text-slate-500 py-3 text-center" data-testid="activity-empty">No activity recorded{filter !== 'all' ? ' for this filter' : ' yet'}.</p>}
          {!!events.length && (
            <ol className="relative border-l-2 border-slate-200 ml-3 space-y-3 max-h-80 overflow-y-auto pr-1" data-testid="activity-list">
              {events.map((e, i) => { const [Icon, cls, label] = KIND[e.type] || KIND.edit; return (
                <li key={i} className="ml-4 relative" data-testid={`activity-item-${e.type}`}>
                  <span className={`absolute -left-[25px] top-0.5 h-5 w-5 rounded-full flex items-center justify-center ${cls}`}><Icon className="h-3 w-3" /></span>
                  <div className="flex items-start gap-2 flex-wrap">
                    <p className="text-sm font-semibold text-slate-800">{e.title}</p>
                    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold uppercase ${cls}`}>{label}</span>
                    <span className="text-[11px] text-slate-400 ml-auto whitespace-nowrap">{fmtDate(e.at)}</span>
                  </div>
                  {(e.detail || e.by) && <p className="text-xs text-slate-500 break-all">{e.detail}{e.by ? <span className="text-slate-400"> · by {e.by}</span> : null}</p>}
                </li>); })}
            </ol>
          )}
        </>
      )}
    </div>
  );
};
